<template>
  <div>
    <div v-if="!isTablet">
      <b-form
        class="needs-validation"
        novalidate
        id="form-credit-card"
        @submit.prevent="processPayment"
      >
        <b-row>
          <b-col cols="6">
            <b-form-group
              class="mb-0 group-card-number"
              :label="$t('payment.methods.creditCard.creditCardNumber')"
              label-for="card-number"
            >
              <b-form-input
                id="card-number"
                :placeholder="$t('payment.methods.creditCard.creditCardNumberDesc')"
                v-model="cardInformation.number"
                name="number"
                :class="{ 'is-invalid': $v.cardInformation.number.$error }"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="$v.cardInformation.number.$error"
              >{{$t('Please check the card number')}}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              class="mb-0 group-card-name"
              :label="$t('payment.methods.creditCard.holderName')"
              label-for="card-holder-name"
            >
              <b-form-input
                id="card-holder-name"
                :placeholder="$t('payment.methods.creditCard.holderNameDesc')"
                v-model="cardInformation.name"
                name="name"
                :class="{ 'is-invalid': $v.cardInformation.name.$error }"
              ></b-form-input>
              <b-form-invalid-feedback>{{$t('Please check name in the card')}}</b-form-invalid-feedback>
            </b-form-group>

            <div class="wrap-date-and-ccv d-flex justify-content-between">
              <b-form-group
                class="mb-0 group-card-expiration-date"
                :label="$t('payment.methods.creditCard.cardExpiration')"
                label-for="card-expiration-date"
              >
                <b-form-input
                  id="card-expiration-date"
                  :placeholder="$t('payment.methods.creditCard.cardExpirationDesc')"
                  v-model="cardInformation.expiration"
                  name="expiration"
                  :class="{ 'is-invalid': $v.cardInformation.expiration.$error }"
                ></b-form-input>
                <b-form-invalid-feedback>{{$t('Please check the expiry date in the card')}}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                class="mb-0 group-card-ccv"
                :label="$t('payment.methods.creditCard.ccv')"
                label-for="card-ccv"
              >
                <b-form-input
                  id="card-ccv"
                  :placeholder="$t('payment.methods.creditCard.ccvDesc')"
                  v-model="cardInformation.ccv"
                  name="ccv"
                  :class="{ 'is-invalid': $v.cardInformation.ccv.$error }"
                ></b-form-input>
                <b-form-invalid-feedback>{{$t('Please check the CCV number')}}</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </b-col>
          <b-col cols="6" class="wrap-card">
            <div class="card-wrapper"></div>
          </b-col>
        </b-row>
        <div class="wrap-btn-payment">
          <b-spinner v-if="loading" label="Loading..." variant="success"></b-spinner>
          <b-button v-else class="btn-payment" id="credit-card-button" type="submit">{{ formattedAmount }}</b-button>
          <br />
          <b-img src="/images/secured.png" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
        </div>
      </b-form>
    </div>
    <div v-if="isTablet">
      <b-row>
        <b-col cols="12" class="wrap-card">
          <div class="card-wrapper"></div>
        </b-col>
        <b-col cols="12">
          <b-form id="form-credit-card" @submit.prevent="processPayment">
            <b-form-group
              class="mb-0 group-card-number"
              :label="$t('payment.methods.creditCard.creditCardNumber')"
              label-for="card-number"
            >
              <b-form-input
                id="card-number"
                :placeholder="$t('payment.methods.creditCard.creditCardNumberDesc')"
                v-model="cardInformation.number"
                :class="{ 'is-invalid': $v.cardInformation.number.$error }"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback">{{$t('Please enter your card number')}}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              class="mb-0 group-card-name"
              :label="$t('payment.methods.creditCard.holderName')"
              label-for="card-holder-name"
            >
              <b-form-input
                id="card-holder-name"
                :placeholder="$t('payment.methods.creditCard.holderNameDesc')"
                v-model="cardInformation.name"
                :class="{ 'is-invalid': $v.cardInformation.name.$error }"
              ></b-form-input>
              <b-form-invalid-feedback id="input-1-live-feedback">{{$t('Please enter name on your card')}}</b-form-invalid-feedback>
            </b-form-group>
            <div class="wrap-date-and-ccv d-flex justify-content-between">
              <b-form-group
                class="mb-0 group-card-expiration-date"
                :label="$t('payment.methods.creditCard.cardExpiration')"
                label-for="card-expiration-date"
              >
                <b-form-input
                  id="card-expiration-date"
                  :placeholder="$t('payment.methods.creditCard.cardExpirationDesc')"
                  v-model="cardInformation.expiration"
                  :class="{ 'is-invalid': $v.cardInformation.expiration.$error }"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >{{$t('Please enter the expiry date of your card')}}</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                class="mb-0 group-card-ccv"
                :label="$t('payment.methods.creditCard.ccv')"
                label-for="card-ccv"
              >
                <b-form-input
                  id="card-ccv"
                  :placeholder="$t('payment.methods.creditCard.ccvDesc')"
                  v-model="cardInformation.ccv"
                  :class="{ 'is-invalid': $v.cardInformation.ccv.$error }"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >{{$t('Please enter the 3 digit cvv number from back of your card')}}</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <b-spinner v-if="loading" label="Loading..." variant="'primary'"></b-spinner>
            <b-button v-else class="btn-payment primary success-button" id="credit-card-button" type="submit">{{ formattedAmount }}</b-button>
          </b-form>
        </b-col>
        <div class="wrap-btn-payment">
          <b-img src="/images/secured.png" :alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"/>
        </div>
      </b-row>
    </div>
  </div>
</template>
<script>
import Card from "card";
import $ from "jquery";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import * as actionType from "../../../controllers/ActionTypes";
import { required, email, minLength } from "vuelidate/lib/validators";
import getEnv from '@/utils/env'
export default {
  name: "creditCard",
  props: {
    formattedAmount: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      cardInformation: {
        number: "",
        ccv: "",
        name: "",
        expiration: ""
      },
      loading: false
    };
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    }
  },
  computed: {
    ...mapGetters("UserController", ["isTablet"])
  },

  validations: {
    cardInformation: {
      number: { required, min: minLength(14), max: minLength(14) },
      ccv: { required, min: minLength(3) },
      name: { required, min: minLength(3) },
      expiration: { required, min: minLength(4) }
    }
  },

  methods: {
    ...mapActions("PaymentController", [actionType.PAY]),
    processPayment(evt) {
      this.$v.cardInformation.$touch();
      
      if (this.$v.cardInformation.$error) {
        return;
      }
      this.loading = true;
      var vm = this;
      Omise.setPublicKey(getEnv('VUE_APP_OMISEKEY'));
      var year = this.cardInformation.expiration.split("/")[1];
      var month = this.cardInformation.expiration.split("/")[0];
      var tokenParameters = {
        expiration_month: month,
        expiration_year: year,
        name: vm.cardInformation.name,
        number: vm.cardInformation.number,
        security_code: vm.cardInformation.ccv
      };
      Omise.createToken("card", tokenParameters, function(
        statusCode,
        response
      ) {
        if (response.object === "error") {
          response.id = "invalid_card";
        }
        vm.PAY({
          card_token: response.id,
          user_payment_id: vm.orderId
        })
          .then(function(response) {
            vm.loading = false;
            vm.redirectUser(true);
          })
          .catch(function(error) {
            vm.loading = false;
            vm.redirectUser(false);
          });
      });
    },
    redirectUser(success) {
      this.$router.push({
        name: "PaymentSuccess",
        params: {
          success: success,
          id: this.orderId,
          previousPendingPaymentId: this.previousPendingPaymentId
        }
      });
    }
  },
  mounted() {
    setTimeout(() => {
      $(function() {
        const plugin = document.createElement("script");
        plugin.setAttribute("src", "https://cdn.omise.co/omise.js");
        plugin.async = true;
        document.head.appendChild(plugin);
        var card = new Card({
          form: "#form-credit-card",
          container: ".card-wrapper",
          placeholders: {
            number: "**** **** **** ****",
            name: "FULL NAME",
            expiry: "**/****",
            cvc: "***"
          },
          formSelectors: {
            numberInput: "#card-number",
            expiryInput: "#card-expiration-date",
            cvcInput: "#card-ccv",
            nameInput: "#card-holder-name"
          }
        });
      });
    }, 500);
  }
};
</script>
<style >
.form-group label{
  text-align: left;
  padding-right: inherit;
}
</style>